import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '../../services/wealthlane-customer-services';
import { TradeOrderService } from '../../services/wealthlane-award-settlement-services';
import { TransferAllocateService } from '../../services/wealthlane-award-services';

const useGetTransferStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const TransferStatus = useQuery(
    ['getTransferStatus'],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateTransferStatuses()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return TransferStatus;
};

export default useGetTransferStatus;
